import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Table, Badge, Card, Breadcrumb } from 'react-bootstrap';
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import logoImage from '../../assets/images/logo.png';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import Download_Letter from '../../modalPopup/Download_Letter';
import { Skeleton } from 'primereact/skeleton';
import { toWords } from "number-to-words";
import noUserImg from "../../assets/images/no_user.png";
import { Sidebar } from 'primereact/sidebar';

import stampImage from '../../assets/images/stamp.jpg';
const Letter_document = () => {
    const [visible, setVisible] = useState(false);
    const { accessToken, userId } = useAuth();
    const [selectedLetter, setSelectedLetter] = useState(null); // State for selected letter
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [selectedpayslip, setSelectedpayslip] = useState(null);
    const lossOfPayDays = selectedpayslip
        ? (selectedpayslip.absentDays ?? 0)
        - (selectedpayslip.adjustmentLeave ?? 0)
        - (selectedpayslip.paidLeaveUsed ?? 0)
        : 0;

    const leaveDeduction = selectedpayslip
        ? Math.round(
            ((selectedpayslip.grossSalary ?? 0) * lossOfPayDays) /
            (selectedpayslip.totalWorkingDays || 1)
        )
        : 0;

    const salaryAfterLeave = selectedpayslip
        ? (selectedpayslip.grossSalary ?? 0) - leaveDeduction
        : 0;

    const totalSalaryPaid = selectedpayslip
        ? salaryAfterLeave
        + (selectedpayslip.overtime ?? 0)
        + (selectedpayslip.arrearSalary ?? 0)
        : 0;

    const totalDeductions = selectedpayslip
        ? (selectedpayslip.ptax ?? 0)
        + (selectedpayslip.TDS ?? 0)
        + (selectedpayslip.adjustmentPaid ?? 0)
        + (selectedpayslip.deductions ?? 0)
        : 0;

    const fetchData = async () => {
        setLoading(true); // Set loading to true before fetching
        try {
            const response = await axios.get(`${config.apiBASEURL}/letterRoutes/fetch-send-letters-by-user`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { user_id: userId }, // Pass user_id as a query parameter
            });
            setData(response.data);
        } catch (error) {
            console.error('Error fetching send letters:', error);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };

    // Call fetchData when accessToken or userId changes
    useEffect(() => {
        if (accessToken && userId) {
            fetchData();
        }
    }, [accessToken, userId]);


    const downloadPDF = async (letterId) => {
        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/letterRoutes/letters/${letterId}/pdf`,
                { user_id: userId },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.pdfUrl) {
                window.open(response.data.pdfUrl, "_blank"); // Open PDF in a new tab
            } else {
                console.error("PDF URL not found in response");
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setLoading(false);
        }
    };

    const [slips, setSlips] = useState([]); // renamed from employees


    const fetchSlips = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${config.apiBASEURL}/Salary_Generation_Routes/fetch-monthly-slips-by-user/${userId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            // Transform API response into table data
            const mapped = response.data.flatMap((slip) =>
                slip.MonthlySlips.map((m) => ({
                    slNo: m.Msl_id,
                    name: m.Emp_name,
                    profile_image: m.Employee?.profileImage?.image_url || null, // <-- safe
                    createdby: slip.GeneratedBy
                        ? `${slip.GeneratedBy.first_name} ${slip.GeneratedBy.last_name}`
                        : "N/A",
                    designation: m.Designation,
                    month: m.Month,
                    year: m.Year,
                    doj: m.date_of_joining,
                    totalWorkingDays: m.total_days,
                    paidLeaveMonth: m.paid_leave,
                    noOfLate: m.late_count,
                    lateDays: m.late_days,
                    daysOffFull: m.days_off_full,
                    daysOffHalf: m.days_off_half,
                    absentDays: m.Absent_days,
                    paidLeaveUsed: m.Paid_leave_used,
                    balancePaidLeave: "-", // if you calculate this later
                    netOffDay: m.no_of_net_off_day,
                    adjustmentLeave: m.Adjustment_leave,
                    salaryDays: m.no_of_days_for_Salary,
                    extraWorkingDays: m.Extra_Working_days,
                    grossSalary: m.Gross_Salary,
                    salary: m.Salary,
                    arrearSalary: m.Arrear_Salary,
                    totalSalary: m.Total_Salary,
                    overtime: m.Overtime,
                    salaryWithOT: m.Total_including_overtime,
                    ptax: m.P_Tax,
                    deductions: m.Deductions,
                    salaryPayable: m.Salary_Payable,
                    adjustmentPaid: m.Adjustment,
                    netPayable: m.Net_Payable,
                    status: m.Status,
                    remarks: m.Remarks,
                    Payment_Status: m.Payment_Status,
                    Employee_code: m.Employee?.userDetails?.employee_id,
                }))
            );
            setSlips(mapped);
        } catch (err) {
            console.error("❌ Failed to fetch salary slips:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userId && accessToken) {
            fetchSlips();
        }
    }, [userId, accessToken]);





    const statusStyle = (status) => {
        switch (status) {
            case 'Generated':
                return { color: '#4caf50' };
            case 'Confirmed':
                return { color: '#ff9800' };
            case 'Edited':
                return { color: '#ff5722' };
            default:
                return { color: '#000' };
        }
    };

    const actionTemplate = (rowData) => {
        return (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
                {/* View/Download Button */}
                <Button
                    title="View"
                    outlined
                    icon="pi pi-eye"
                    severity="primary"
                    className="p-button-sm border-0"
                    onClick={() => {
                        setSelectedLetter(rowData); // Set selected letter data
                        setVisible(true); // Show modal or component
                    }}
                />
                <Button
                    title="Download"
                    outlined
                    icon="pi pi-download"
                    severity="help"
                    className="p-button-sm border-0"
                    onClick={() => downloadPDF(rowData.send_letter_id)}
                />
            </div>
        );
    };


    const nameTemplate = (rowData) => {
        return (
            <div className="d-flex align-items-center gap-2">
                <img
                    src={rowData.profile_image || noUserImg}
                    alt={rowData.name}
                    className="rounded-full"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                />
                <div style={{ width: "calc(100% - 40px)" }}>
                    <span>{rowData.name}</span>
                    <small className='d-block'>
                        <span>generated by: {rowData.createdby}</span>
                        <Badge className='bg-success'>{rowData.status}</Badge>
                    </small>
                </div>

            </div>
        );
    };

    // Action buttons
    const actionTemplatesalary = (rowData) => {
        return (
            <div className="flex gap-2">

                <Button icon="pi pi-eye" severity="help" rounded text tooltip="View" onClick={() => onview(rowData)} />

                <Button
                    icon="pi pi-file-pdf"
                    severity="secondary"
                    rounded
                    text
                    tooltip="Download"
                    onClick={() => onGeneratepdf(rowData.slNo)}
                />

            </div>
        );
    };


    const onGeneratepdf = async (slNo) => {
        setLoading(true);
        try {
            const response = await axios.post(`${config.apiBASEURL}/Salary_Generation_Routes/monthly-slips-pdf/${slNo}/pdf`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (response.status === 200) {
                // Refresh slips table
                await fetchSlips();

                // Optionally open the PDF in new tab
                if (response.data.pdfUrl) {
                    window.open(response.data.pdfUrl, "_blank");
                }
            }
        } catch (error) {
            console.error("❌ Delete failed:", error);
            fetchSlips();

        }
    };

    const onview = (rowData) => {
        setVisibleRight(true);
        setSelectedpayslip(rowData);
    }


    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} className="mb-4 d-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Company Documents</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Card>
                        <Card.Header>
                            <h5 className='mb-0'>Letter Documents</h5>
                        </Card.Header>
                        <Card.Body>
                            {loading ? (
                                // Skeleton loader when loading
                                <div>
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                </div>
                            ) : (
                                <>
                                    <Accordion>
                                        {data.map((group, index) => (
                                            <AccordionTab
                                                key={`${group.employee_name}-${index}`}
                                                header={
                                                    <div className="d-flex align-items-center">
                                                        <img
                                                            src={group.user?.profileImage?.image_url || logoImage}
                                                            alt={group.employee_name}
                                                            style={{
                                                                width: '36px',
                                                                height: '36px',
                                                                borderRadius: '50%',
                                                                marginRight: '10px',
                                                            }}
                                                        />
                                                        <span>{group.employee_name}</span>
                                                        <span className="ms-3 badge bg-info" style={{ fontSize: '0.8rem' }}>{group.user?.user_type}</span>
                                                        <span className="ms-3 badge bg-secondary" style={{ fontSize: '0.8rem' }}>{group.letters.length} Letters</span>
                                                    </div>
                                                }
                                            >
                                                <DataTable value={group.letters}>
                                                    <Column field="employee_name" header="Employee" />
                                                    <Column field="subject" header="Subject" />
                                                    <Column
                                                        field="status"
                                                        header="Status"
                                                        body={(rowData) => (
                                                            <span style={statusStyle(rowData.status)}>
                                                                {rowData.status}
                                                            </span>
                                                        )}
                                                    />
                                                    <Column
                                                        field="createdAt"
                                                        header="Creation Date"
                                                        body={(rowData) => {
                                                            const creationDate = new Date(rowData.createdAt);
                                                            return creationDate.toLocaleString("en-GB", {
                                                                day: "2-digit",
                                                                month: "short",   // "Sep" instead of "09"
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                second: "2-digit",
                                                                hour12: true,     // 12-hour clock with AM/PM
                                                            });
                                                        }}
                                                    />

                                                    <Column
                                                        header="Actions"
                                                        body={actionTemplate}
                                                        style={{ width: '150px' }}
                                                    />
                                                </DataTable>
                                            </AccordionTab>
                                        ))}
                                    </Accordion>


                                </>
                            )}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>
                            <h5 className='mb-0'>Salary Slips</h5>
                        </Card.Header>
                        <Card.Body>
                            {loading ? (
                                // Skeleton loader when loading
                                <div>
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                </div>
                            ) : slips.length === 0 ? (
                                <p className="text-muted">No salary slips found.</p>
                            ) : (
                                <DataTable
                                    value={slips}
                                    dataKey="slNo"
                                    scrollable
                                    className="payslip_employee_DT"
                                >

                                    <Column
                                        field="name"
                                        header="Name of Employees"
                                        body={nameTemplate}
                                        frozen
                                        style={{ minWidth: "300px" }}
                                    />

                                    {/* Scrollable Columns */}
                                    <Column field="designation" header="Designation" style={{ minWidth: "180px" }} />
                                    <Column field="doj" header="Date of Joining" style={{ minWidth: "160px" }} className='table-info' />
                                    <Column field="totalWorkingDays" header="Total Working Days" style={{ minWidth: "180px" }} />
                                    <Column field="netPayable" header="Net Payable" style={{ minWidth: "200px" }} />

                                    {/* <Column header="Status" body={statusTemplate} style={{ minWidth: "160px" }} /> */}
                                    <Column field="remarks" header="Remarks" style={{ minWidth: "200px" }} />

                                    {/* Actions Column */}
                                    <Column
                                        header="Actions"
                                        body={actionTemplatesalary}
                                        style={{ minWidth: "130px" }}
                                        frozen
                                        alignFrozen="right"
                                    />
                                </DataTable>
                            )}
                        </Card.Body>
                    </Card>
                    <Dialog
                        visible={visible}
                        maximizable
                        style={{ width: '50vw' }}
                        onHide={() => setVisible(false)}
                        className="letterDw_scroll"
                    >
                        <Download_Letter letter={selectedLetter} /> {/* Pass selected letter as a prop */}
                    </Dialog>

                    <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '800px' }} className='paySlside'>
                        <Table bordered size="sm" className="sl-table">
                            <thead>
                                <tr style={{ border: '0' }}>
                                    <td colspan="3" style={{ padding: '10px', width: '360px', border: '0' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src="https://ik.imagekit.io/blackboxv2/header/header_logo_1_Nm7IPGhVL"
                                                alt="Company Logo"
                                                style={{ height: '170px', width: '170px', objectfit: 'contain' }}
                                            />

                                            <div style={{ width: 'calc(100% - 120px)', marginLeft: '30px' }}>
                                                <h2 style={{ margin: '0 0 0 0', fontSize: '16px', fontWeight: '600', color: '#191919', textTransform: 'uppercase' }}>
                                                    {selectedpayslip?.name}
                                                </h2>

                                                <p style={{ margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919' }}>
                                                    {selectedpayslip?.designation}
                                                </p>
                                                <p style={{ margin: '8px 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919' }}>
                                                    Employment No : <strong>{selectedpayslip?.Employee_code}</strong>
                                                </p>

                                                <p style={{ margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919' }}>
                                                    Date of joining : <strong>{selectedpayslip?.doj}</strong>
                                                </p>

                                                <p style={{ margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919' }}>
                                                    Earnings for : <strong>{selectedpayslip?.month}/{selectedpayslip?.year}</strong>
                                                </p>
                                                <p style={{ margin: '0 0 0 0', fontSize: '13px', fontWeight: '400', color: '#191919' }}>
                                                    No. of Days in this month : <strong>{selectedpayslip?.totalWorkingDays}</strong>
                                                </p>
                                            </div>
                                        </div>
                                    </td>

                                    <td colspan="2" style={{ padding: '22px 10px 10px 10px', textAlign: 'right', verticalAlign: 'top', width: '280px', paddingLeft: '65px', border: '0' }}>
                                        <h3 style={{ margin: '5px 0 10px 0', fontSize: '21px', color: '#000', fontWeight: 'bold' }}>
                                            SALARY PAY SLIP
                                        </h3>
                                        <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#858585' }}>
                                            Payslip For the Month <strong style={{ display: 'block', fontSize: '13px', color: '#191919' }}>{selectedpayslip?.month}/{selectedpayslip?.year}</strong>
                                        </p>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ background: '#cfcfcf' }}>
                                    <th colSpan={3}>EARNINGS</th>
                                    <th colSpan={2}>DEDUCTIONS</th>
                                </tr>
                                <tr>
                                    <td width={'35%'}>
                                        <small>SALARY HEAD </small>
                                        <div>
                                            <span><b>Basic (Gross)</b></span>
                                            <span>Absents </span>
                                            <span>Half Days</span>
                                            <span>No.of lates</span>
                                            <span>Lates Deduction</span>
                                            <span>Total Leaves </span>
                                            <span>Leave Allowed(Adj) </span>
                                            <span>Paid Leave </span>
                                            <span><b>Deduction</b></span>
                                            <span><b>Overtime</b></span>
                                            <span><b>Arrears</b></span>
                                            <strong>SALARY PAID</strong>
                                        </div>
                                    </td>
                                    <td width={'15%'}>
                                        <small>Days</small>
                                        <div>
                                            <span></span>
                                            <span>{selectedpayslip?.daysOffFull}</span>
                                            <span>{selectedpayslip?.daysOffHalf}</span>
                                            <span>{selectedpayslip?.noOfLate}</span>
                                            <span>{selectedpayslip?.lateDays}</span>
                                            <span>{selectedpayslip?.absentDays}</span>
                                            <span>{selectedpayslip?.adjustmentLeave}</span>
                                            <span>{selectedpayslip?.paidLeaveUsed}</span>
                                            <span><b>{lossOfPayDays}</b></span>
                                            <span><b>{selectedpayslip?.extraWorkingDays}</b></span>
                                            <span><b>{selectedpayslip?.arrearSalary}</b></span>
                                            <strong>{selectedpayslip?.salaryDays}</strong>
                                        </div>

                                    </td>
                                    <td width={'15%'}>
                                        <small>AMT. (Rs.)</small>
                                        <div>
                                            <span><b>{selectedpayslip?.grossSalary}</b></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span><b>{leaveDeduction}</b></span>
                                            <span><b>{selectedpayslip?.overtime}</b></span>
                                            <span><b>{selectedpayslip?.arrearSalary}</b></span>
                                            <strong>{selectedpayslip?.salaryWithOT}/-</strong>
                                        </div>
                                    </td>
                                    <td width={'15%'}>
                                        <small>SALARY HEAD</small>
                                        <div>
                                            <span>PF </span>
                                            <span>ESI</span>
                                            <span>P TAX </span>
                                            <span>TDS</span>
                                            <span>Advance</span>
                                            <span>Penalty</span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <strong>Total Deductions</strong>
                                        </div>
                                    </td>
                                    <td width={'15%'}>
                                        <small>AMT. (Rs.)</small>
                                        <div>
                                            <span>0 </span>
                                            <span>0</span>
                                            <span>{selectedpayslip?.ptax}/- </span>
                                            <span>{selectedpayslip?.TDS} </span>
                                            <span>{selectedpayslip?.adjustmentPaid}</span>
                                            <span>{selectedpayslip?.deductions}</span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <strong>{totalDeductions}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr style={{ background: '#ececec' }}>
                                    <th colSpan={3}>Pay - in - Hand</th>
                                    <th colSpan={2}>{selectedpayslip?.netPayable}/-</th>
                                </tr>
                                <tr>
                                    <td colSpan={1}><span>In Words : </span></td>
                                    <td colSpan={4}>
                                        <small>
                                            {selectedpayslip?.netPayable != null && !isNaN(selectedpayslip?.netPayable)
                                                ? `${toWords(Number(selectedpayslip.netPayable))
                                                    .replace(/-/g, " ")
                                                    .toUpperCase()} ONLY.`
                                                : "N/A"}
                                        </small>
                                    </td>

                                </tr>
                                <tr>
                                    <th colSpan={3} className="text-end"><span><img src={stampImage} alt="brand-logo" className="" /></span></th>
                                    <td colSpan={2} className="signature">
                                        <span></span>
                                        <small>Authorized Signatory</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5} className="text-center">
                                        <small className="d-block">193/1 MAHATAMA GANDI ROAD, KOLKATA - 700007</small>
                                        <small>Email: <a href="mailto:Saurabh@thegraphe.com" className="text-primary">Saurabh@thegraphe.com</a></small>
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                    </Sidebar>

                </Row>
            </Row>
        </>
    );
};

export default Letter_document;
